// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"ad462c8b","187":"a2eed8b1","787":"c6f2846b","855":"0467bb37","927":"f8b599ff","989":"6c749462"}[chunkId] + ".chunk.js";
};